import { toast } from 'react-toastify';

// Imported/exported here so it can be wrapped at a later date
export default toast;
